import style from "./Organisasjonsnummer.module.less";

interface OrganisasjonsnummerProps {
  orgNr?: string;
}

export function Organisasjonsnummer({ orgNr }: OrganisasjonsnummerProps) {
  if (!orgNr) {
    return <></>;
  }

  const sections = [orgNr.slice(0, 3), orgNr.slice(3, 6), orgNr.slice(6)];

  return (
    <span key={`orgnr_${orgNr}`} className={style.organisasjonsnummer}>
      {sections.map((section, index) => (
        <span key={index}>{section}</span>
      ))}
    </span>
  );
}
